"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOfferMessagesContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../../schemas");
const messages_request_1 = require("./messages.request");
const messages_response_1 = require("./messages.response");
const c = (0, core_1.initContract)();
exports.JobOfferMessagesContract = c.router({
    list: {
        method: 'GET',
        path: '/',
        pathParams: messages_request_1.OfferMessagesListPathParamsSchema,
        responses: { 200: messages_response_1.OfferMessagesListResponseSchema },
    },
    findById: {
        method: 'GET',
        path: '/:messageId',
        pathParams: messages_request_1.OfferMessageIdPathParamsSchema,
        responses: { 200: messages_response_1.OfferMessageDetailResponseSchema },
    },
    create: {
        method: 'POST',
        path: '/',
        pathParams: messages_request_1.OfferMessagesListPathParamsSchema,
        body: messages_request_1.OfferMessageCreateRequestSchema,
        responses: { 201: schemas_1.BaseResponseSchema },
    },
    update: {
        method: 'PATCH',
        path: '/:messageId',
        pathParams: messages_request_1.OfferMessageIdPathParamsSchema,
        body: messages_request_1.OfferMessageUpdateRequestSchema,
        responses: { 200: schemas_1.BaseResponseSchema },
    },
    delete: {
        method: 'DELETE',
        path: '/:messageId',
        pathParams: messages_request_1.OfferMessageIdPathParamsSchema,
        responses: { 200: schemas_1.BaseResponseSchema },
    },
}, { pathPrefix: '/:offerId/messages' });
